export const IMAGE_EFFECTS = {
  STRETCH_TO_FIT: 'STRETCH_TO_FIT',
  REPEAT: 'REPEAT',
  BLUR: 'BLUR',
};

export const IMAGE_EFFECTS_BG_SIZE = {
  STRETCH_TO_FIT: 'cover',
  REPEAT: '50px',
  BLUR: 'cover',
};
